import { render, staticRenderFns } from "./PhoneRouter.vue?vue&type=template&id=f2e44bd8&"
import script from "./PhoneRouter.vue?vue&type=script&lang=js&"
export * from "./PhoneRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports